import axios from 'axios'

export default {
  getInfo () {
    return axios.get('/api/dashboard/info')
  },
  getDisasters () {
    return axios.get('/api/dashboard/disasters')
  },
  getReports () {
    return axios.get('/api/dashboard/reports')
  },
  getWeathers () {
    return axios.get('/api/weathers')
  }
}
